import { useMemo } from "react";

import { useAllClients } from "~/modules/client/api/client/clientQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { getInputDefaultOptionsData, mapDataToInputOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useClientSelectOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: allClientsData } = useAllClients();
	return useMemo(() => {
		if (allClientsData) {
			const clientsSorted = [...allClientsData].sort(byObjectProperty("displayName"));
			const options = mapDataToInputOptionsData(clientsSorted, "id", "displayName");

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [allClientsData, includeCtaOption]);
};

export default useClientSelectOptions;

